/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReportsService {
    /**
     * Get a report
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns Reports Successfully retrieved report
     * @throws ApiError
     */
    public static postReports(
        workspaceId: string,
        requestBody: {
            query: string;
        },
    //NOTE: response type is incorrect in docs, DO NOT CHANGE
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/reports',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
}
